// أسماء الملفات الأصلية (من غير أي imports عشان تتستخدم في أي مكان / الاختبارات).

const IMAGE_EXTS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'bmp', 'svg'];
const VIDEO_EXTS = ['mp4', 'webm', 'ogg'];

export const normalizeAttachmentList = (attachments) => (
    Array.isArray(attachments) ? attachments : attachments ? [attachments] : []
).filter(Boolean).map(String);

// { [url]: name } من attachmentNames (مصفوفة أو object).
export const buildAttachmentNameMap = (attachmentNames) => {
    const map = {};
    if (Array.isArray(attachmentNames)) {
        attachmentNames.forEach((item) => {
            if (item?.url && item?.name) map[String(item.url)] = String(item.name);
        });
    } else if (attachmentNames && typeof attachmentNames === 'object') {
        Object.entries(attachmentNames).forEach(([url, name]) => {
            if (url && name) map[url] = String(name);
        });
    }
    return map;
};

// { [url]: name } → [{ url, name }] للملفات اللي لسه موجودة بس.
export const toAttachmentNamesPayload = (nameMap, urls) =>
    normalizeAttachmentList(urls)
        .filter((url) => nameMap?.[url])
        .map((url) => ({ url, name: nameMap[url] }));

const getExt = (value) => {
    const parts = String(value || '').split('?')[0].split('.');
    if (parts.length <= 1) return '';
    let ext = parts.pop().toLowerCase();
    if (ext && !Number.isNaN(Number(ext)) && parts.length > 1) ext = parts.pop().toLowerCase();
    return ext;
};

export const getAttachmentInfo = (url, attachmentNames) => {
    const fileName = url ? decodeURIComponent(String(url).split('?')[0].split('/').pop() || '') : '';
    const storedName = buildAttachmentNameMap(attachmentNames)[String(url || '')] || '';
    const fallbackName = fileName.replace(/^\d+-[a-f0-9-]+-/, '') || fileName;
    const name = storedName || fallbackName;
    const ext = getExt(storedName) || getExt(fileName);
    return {
        url,
        name,
        hasOriginalName: Boolean(storedName),
        ext,
        isImage: IMAGE_EXTS.includes(ext),
        isVideo: VIDEO_EXTS.includes(ext),
        isPdf: ext === 'pdf'
    };
};
